<template>
  <div class="flex flex-col flex-1">
    <div class="flex flex-col gap-4 place-items-center place-content-center flex-1">
      <slot name="icon">
        <aha-icon name="bin-empty" maintain-color />
      </slot>
      <slot name="content" class="flex flex-col gap-4">
        <div v-if="!shared" class="text-base font-bold">
          {{ $i18nPresenter.t('No presentations here yet') }}
        </div>
        <div v-else class="text-base font-bold">
          {{ $i18nPresenter.t('No shared presentations here yet') }}
        </div>
        <div class="text-base-80">
          <p v-if="shared">
            {{ $i18nPresenter.t('When someone shares their presentation with you, it will show up here.') }}
          </p>
          <p v-else>
            {{ $i18nPresenter.t('You can create and import a presentation here.') }}
          </p>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
